import { instance } from '../../util/http'
import apis from '../../config/apis'

// 获取用户关注统计详情列表
const list = () => {
    return instance.get(apis.Follow.List)
}

// 获取用户库存码详情
const pCodeList = (page,limit) => {
    return instance.get(apis.Follow.pCodeDetail + "?page=" + page + "&pageSize=" + limit)
}

// 获取用户库存码详情
const pCodePageList = (page,limit) => {
    return instance.get(apis.Follow.pCodePageList + "?page=" + page + "&pageSize=" + limit)
}

export default {
	list,
    pCodeList,
    pCodePageList
}